/**
 * Created by Jerker Nord on 2024-01-24.
 */
import {Loner} from "../../../Loner";
import {LonerGameAssets} from "../../../LonerGameAssets";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {LonerGameMode} from "../../../server/LonerGameMode";
import {gsap} from "gsap";
import {LonerSound} from "../../../sound/LonerSound";

export class LonerSSDAmmo extends PIXI.Container {

    private static AMMO_BACKGROUND_POSITION:PIXI.Point = new PIXI.Point(-20, -6);

    private _bullets:PIXI.Sprite[];
    private _bulletsEmpty:PIXI.Sprite[];
    private _bulletContainer:PIXI.Container;
    private _ammoCounter:number;
    private _reloadTL:gsap.core.Timeline;
    private _oneShotLeftTL:gsap.core.Timeline;
    private _ammoBackground:PIXI.Sprite;

    constructor() {
        super();
        this.init();
    }

    private init():void {
        this._ammoCounter = 5;

        this._ammoBackground = new PIXI.Sprite(Loner.assetLoader.getTextures(LonerGameAssets.SSD_BULLET_BACKGROUND)[0]);
        this._ammoBackground.position = LonerSSDAmmo.AMMO_BACKGROUND_POSITION;
        this.addChild(this._ammoBackground);

        this._bulletContainer = new PIXI.Container();
        this.addChild(this._bulletContainer);

        let tempBullet:PIXI.Sprite;
        this._bullets = [];
        for(let i:number = 0; i < 5; i++) {
            tempBullet = new PIXI.Sprite(Loner.assetLoader.getTextures(LonerGameAssets.SSD_BULLET)[0]);
            tempBullet.position.x = tempBullet.width * i;
            this._bullets.push(tempBullet);
            this._bulletContainer.addChild(tempBullet);
        }
        this._bullets.reverse();

        this._bulletsEmpty = [];
        for(let i:number = 0; i < 5; i++) {
            tempBullet = new PIXI.Sprite(Loner.assetLoader.getTextures(LonerGameAssets.SSD_BULLET_EMPTY)[0]);
            tempBullet.position.x = tempBullet.width * i;
            tempBullet.alpha = 0;
            this._bulletsEmpty.push(tempBullet);
            this._bulletContainer.addChild(tempBullet);
        }
        this._bulletsEmpty.reverse();

        this._reloadTL = gsap.timeline({paused : true});
        //Fill up one bullet at a time

        this._oneShotLeftTL = gsap.timeline({paused:true, repeat:-1});
        this._oneShotLeftTL.add([gsap.to(this._bullets[0], {duration : 0.6, alpha : 0}),()=>{
            Loner.soundPlayer.playSound(LonerSound.SSD_LAST_AMMO_LEFT);
        }]);
        this._oneShotLeftTL.add(()=>{this._bullets[0].alpha = 1});
    }

    public getReloadTL():gsap.core.Timeline {
        return this._reloadTL.restart();
    }

    public getOneShotLeftTL():gsap.core.Timeline {
        return this._oneShotLeftTL.restart();
    }

    public stopOneShotLeftTL():void{
        this._oneShotLeftTL.pause();
        this._bullets[0].alpha = 1;
    }

    public setAmmo(bullets:number):void {
        if (bullets == 5){
            this.getReloadTL();
        }
        if (bullets == 1){
            this.getOneShotLeftTL();
        }
        if ((bullets > 1 && this._oneShotLeftTL.isActive()) || bullets == 0){
            this.stopOneShotLeftTL();
        }
        Loner.model.freespinsLeft = bullets;
        if(Loner.model.data.nextMode == LonerGameMode.FEATURE_SHOOT_SHOOT_DUCK) {
            SlotGame.keypadPlugin.setZeroBetSpinCounter(Math.max(bullets, 0));
        }

        this._ammoCounter = bullets;
        for(let i:number = 0; i < 5; i++) {
            if(i < bullets) {
                this._bullets[i].alpha = 1;
                this._bulletsEmpty[i].alpha = 0;
            } else {
                this._bullets[i].alpha = 0;
                this._bulletsEmpty[i].alpha = 1;
            }
        }
    }

    public decreaseAmmo():void {
        this.setAmmo(this._ammoCounter - 1);
    }

    public reset():void {
        this.setAmmo(5);
        if (this._oneShotLeftTL && this._oneShotLeftTL.isActive()){
            this.stopOneShotLeftTL();
        }
        if (this._reloadTL && this._reloadTL.isActive()){
            this._reloadTL.pause();
        }
        this._bullets[0].alpha = 1;
    }
}